import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import VueHead from 'vue-head'
Vue.use(VueHead)
import Resource from 'vue-resource'
Vue.use(Resource)

import home from './containers/Home'
import food from './containers/Food'
import takeaway from './containers/Takeaway'
import projects from './containers/Projects'
import about from './containers/About'

// import updates from './containers/Updates'
// import config from './containers/Config'
// import singleupdate from './containers/SingleUpdate'
import fourzerofour from './containers/404'

// routes
const routes = [
  { name: 'home', path: '/', component: home },
  { name: 'food', path: '/food', component: food },
  { name: 'takeaway', path: '/takeaway', component: takeaway },
  { name: 'projects', path: '/projects', component: projects },
  { name: 'about', path: '/about', component: about },
  { name: '404', path: '*', component: fourzerofour }
]
// export router instance
export default new Router({
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  base: '',
  routes,
  linkActiveClass: 'is-active'
})



// WEBPACK FOOTER //
// ./src/router.js